import { UserPermission } from '@globaleris/ui.library'
import { Button } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ButtonWithPermissions from '../../../../components/buttonWithPermissions/buttonWithPermissions'
import { hasPermission } from '../../../../helpers/permissionsHelper'
import { Resources } from '../../../../model/RBAC/constants'

interface ProfileEditHeaderActionsProps {
  onEditClick: () => void
  onBackButtonClick: () => void
  onDeleteClick: () => void
  canDelete: boolean
  isCheckingDelete: boolean
}

export const ProfileEditActions: React.FC<ProfileEditHeaderActionsProps> = ({
  onEditClick,
  onBackButtonClick,
  onDeleteClick,
  canDelete,
  isCheckingDelete
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'profiles'])

  return (
    <>
      <Button onClick={onBackButtonClick} size="small" color="primary">
        {t('profiles:header.actions.back')}
      </Button>
      <ButtonWithPermissions
        onClick={onDeleteClick}
        size="small"
        color="primary"
        hasPermission={
          hasPermission(Resources.InvoicesPage, [UserPermission.EDIT]) &&
          hasPermission(Resources.Leads, [UserPermission.EDIT])
        }
        disabled={!canDelete || isCheckingDelete}
      >
        {t('profiles:header.actions.delete')}
      </ButtonWithPermissions>
      <ButtonWithPermissions
        variant="contained"
        color="primary"
        size="small"
        hasPermission={
          hasPermission(Resources.InvoicesPage, [UserPermission.EDIT]) &&
          hasPermission(Resources.Leads, [UserPermission.EDIT])
        }
        onClick={onEditClick}
      >
        {t('profiles:header.actions.edit')}
      </ButtonWithPermissions>
    </>
  )
}
